import axios from "axios";

const buildBracketParam = (values) =>
  Array.isArray(values) && values.length > 0 ? `[${values.map((v) => JSON.stringify(v)).join(",")}]` : "";

// GET /general/countryParameters
export const fetchCountryParameters = ({
  search = "",
  countries = [],
  codes = [],
  page = 1,
  limit = 40,
  orderColumn = "code",
  orderBy = "asc",
} = {}) => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  const countriesParam = buildBracketParam(countries);
  if (countriesParam) params.append("countries", countriesParam);
  const codesParam = buildBracketParam(codes);
  if (codesParam) params.append("codes", codesParam);
  params.append("page", page);
  params.append("limit", limit);
  if (orderColumn) params.append("orderColumn", orderColumn);
  if (orderBy) params.append("orderBy", orderBy);

  return axios
    .get(`/general/countryParameters?${params.toString()}`, {
      headers: { Accept: "application/json" },
    })
    .then((res) => res.data);
};

// DELETE /general/countryParameters/{parameterId} (soft delete -> isActive = 0)
export const deleteCountryParameter = (parameterId) =>
  axios.delete(`/general/countryParameters/${parameterId}`).then((res) => res.data);

// PUT /general/countryParameters/{parameterId}
export const updateCountryParameter = (parameterId, payload) =>
  axios.put(`/general/countryParameters/${parameterId}`, payload).then((res) => res.data);
